import { useMutation } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import CreateMutation from 'mutations/space/create';
import Form from 'components/space/form';

const Create = ({ handleClose, onSuccess }) => {
  const setError = useError();

  const [createMutation, { loading }] = useMutation(CreateMutation, {
    onCompleted: ({ createSpace }) => {
      onSuccess(createSpace.space);
    },
    onError: () => {
      setError('error.space.create');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.space.create" />
      </ModalTypography>
      <Form
        initialValues={{ name: '' }}
        processing={loading}
        onSubmit={(values) => createMutation({ variables: values })}
        onCancel={handleClose}
      />
    </>
  );
};

export default Create;
